import { WakeupReason as WatchdogWakeupReason } from '@wix/ambassador-asa-participant-v1-participant/types';
import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export { WatchdogWakeupReason };
export let ParticipantStatus = /*#__PURE__*/function (ParticipantStatus) {
  ParticipantStatus["UNKNOWN"] = "UNKNOWN";
  ParticipantStatus["PENDING"] = "PENDING";
  ParticipantStatus["SCHEDULED"] = "SCHEDULED";
  ParticipantStatus["PAUSED"] = "PAUSED";
  ParticipantStatus["IN_PROGRESS"] = "IN_PROGRESS";
  ParticipantStatus["USER_INTERVENTION"] = "USER_INTERVENTION";
  ParticipantStatus["FAILED_TO_CONTACT"] = "FAILED_TO_CONTACT";
  ParticipantStatus["INVALID"] = "INVALID";
  return ParticipantStatus;
}({});
export const isValidParticipant = participant => isValidBase(participant) && validateProps(participant, ['contactId', 'actionId', 'status']);
//# sourceMappingURL=Participant.js.map